"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const ModalControlDefault_1 = require("./ModalControlDefault");

const styles_1 = require("../styles");

const Icons_1 = require("../../Icons");

const ModalWrapper_1 = require("../ModalWrapper");

const styles_2 = require("./styles");

const ModalControl = props => {
  const {
    children,
    onClose,
    parentRef,
    position,
    height,
    modalId = 'modal',
    title
  } = props;

  if (!parentRef) {
    return null;
  }

  if (position === 'top') {
    if (!height) {
      return null;
    }

    if (isNaN(parseInt(height)) || parseInt(height) === 0) {
      return null;
    }
  }

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(ModalWrapper_1.ModalWrapper, {
      modalId: modalId,
      backgroundColor: '#ffffff00',
      isRemovable: false
    }, void 0), (0, jsx_runtime_1.jsx)(ModalControlDefault_1.ModalControlDefault, Object.assign({}, props, {
      children: (0, jsx_runtime_1.jsxs)(styles_1.StyledModal, Object.assign({
        id: modalId,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": `${modalId}_label`
      }, {
        children: [(0, jsx_runtime_1.jsx)(styles_2.StyledTitle, {
          children: title
        }, void 0), (0, jsx_runtime_1.jsx)(styles_2.StyledControlButtonClose, {
          children: (0, jsx_runtime_1.jsx)(Icons_1.CloseCircled, {
            onClick: onClose
          }, void 0)
        }, void 0), children]
      }), void 0)
    }), void 0)]
  }, void 0);
};

exports.default = ModalControl;